"use strict";
var appn;
(function (appn) {
    var dashboards;
    (function (dashboards_1) {
        var views;
        (function (views) {
            var dashboards;
            (function (dashboards) {
                var create;
                (function (create) {
                    class InitArgs {
                        constructor() {
                            this.redirectUrl = appn.emptyString;
                        }
                    }
                    let _initArgs;
                    function init(args) {
                        _initArgs = args;
                        if (_initArgs.redirectUrl) {
                            appn.location.navTo(_initArgs.redirectUrl);
                            return;
                        }
                        appn.select.init({
                            selector: 'select#iconsToDisplay',
                            isIconSelect: true
                        });
                    }
                    create.init = init;
                })(create = dashboards.create || (dashboards.create = {}));
            })(dashboards = views.dashboards || (views.dashboards = {}));
        })(views = dashboards_1.views || (dashboards_1.views = {}));
    })(dashboards = appn.dashboards || (appn.dashboards = {}));
})(appn || (appn = {}));
